module.exports = __webpack_public_path__ + "img/next.aa390cbb.svg";